export const NOTIFICATIONS = {
    filters: [
        { label: 'All', value: 'all', isSelected: true },
        { label: 'Read', value: 'read', isSelected: false },
        { label: 'Unread', value: 'unread', isSelected: false },
        { label: 'Follow-up Required', value: 'followupRequired', isSelected: false },
        { label: 'Emergency', value: 'emergency', isSelected: false },
        { label: 'Warning', value: 'warning', isSelected: false },
    ]
};